module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', [_c('div', [_vm._v("\n            Debug:\n            "), _c('br'), _vm._v(" "), _c('audio', {
    ref: "audio",
    attrs: {
      "controls": ""
    }
  }, [(_vm.player.audio) ? _c('source', {
    attrs: {
      "src": _vm.player.audio.previewSource,
      "type": "audio/mpeg"
    }
  }) : _vm._e(), _vm._v("\n                Your browser does not support the audio element.\n            ")]), _vm._v(" "), _c('br'), _vm._v("\n\n            Use these controls:\n            "), _c('br')]), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    ref: "time",
    staticClass: "semi-bold text-xs-center",
    attrs: {
      "id": "time-tooltip"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tooltipTime) + "\n                    ")]), _vm._v(" "), _c('v-progress-linear', {
    staticClass: "grey lighten-2 ma-0 pa-0",
    attrs: {
      "buffer-value": _vm.bufferValue,
      "buffer": "",
      "id": "progress-bar",
      "height": "10"
    },
    on: {
      "click": _vm.onClick,
      "mousemove": function($event) {
        _vm.showTime($event)
      },
      "mouseout": function($event) {
        _vm.hideTime($event)
      }
    },
    model: {
      value: (_vm.buffer),
      callback: function($$v) {
        _vm.buffer = $$v
      },
      expression: "buffer"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "text-xs-center"
  }, [_c('v-flex', [_c('v-btn', {
    ref: "repeat",
    staticClass: "elevation-0 ml-0 mr-0",
    attrs: {
      "flat": "",
      "icon": ""
    },
    on: {
      "click": _vm.toggleRepeat
    }
  }, [(_vm.player.repeat === 0) ? _c('v-icon', {
    staticClass: "grey--text"
  }, [_vm._v("repeat")]) : (_vm.player.repeat === 1) ? _c('v-icon', [_vm._v("repeat_one")]) : _c('v-icon', [_vm._v("repeat")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0 ml-0 mr-0",
    attrs: {
      "disabled": !_vm.player.playlist.length,
      "flat": "",
      "icon": ""
    },
    on: {
      "click": _vm.playPrevious
    }
  }, [_c('v-icon', [_vm._v("skip_previous")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.player.state !== 1),
      expression: "player.state !== 1"
    }],
    staticClass: "elevation-1 ml-0 mr-0",
    attrs: {
      "disabled": !_vm.player.audio,
      "large": "",
      "icon": "",
      "dark": "",
      "color": !_vm.player.audio ? 'grey lighten-1' : 'secondary'
    },
    on: {
      "click": function($event) {
        _vm.player.state = 1
      }
    }
  }, [_c('v-icon', [_vm._v("play_arrow")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.player.state === 1),
      expression: "player.state === 1"
    }],
    staticClass: "elevation-1 ml-0 mr-0",
    attrs: {
      "disabled": !_vm.player.audio,
      "large": "",
      "icon": "",
      "color": "secondary",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.player.state = 2
      }
    }
  }, [_c('v-icon', [_vm._v("pause")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0 ml-0 mr-0",
    attrs: {
      "disabled": !_vm.canNext,
      "flat": "",
      "icon": ""
    },
    on: {
      "click": _vm.playNext
    }
  }, [_c('v-icon', [_vm._v("skip_next")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0 ml-0 mr-0",
    attrs: {
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.player.shuffle = !_vm.player.shuffle
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": _vm.player.shuffle ? '' : 'grey'
    }
  }, [_vm._v("shuffle")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_vm._v("\n                Playlist:\n                "), (_vm.player.playlist) ? _c('v-list', [_c('draggable', {
    attrs: {
      "options": _vm.draggableOptions
    },
    on: {
      "start": _vm.onDragStart,
      "end": _vm.onDragEnd
    },
    model: {
      value: (_vm.player.playlist),
      callback: function($$v) {
        _vm.$set(_vm.player, "playlist", $$v)
      },
      expression: "player.playlist"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "list"
    }
  }, _vm._l((_vm.player.playlist), function(audio, i) {
    return _c('v-list-tile', {
      key: i,
      staticClass: "hover-show-hidden",
      on: {
        "click": function($event) {
          _vm.player.position = i
        }
      }
    }, [_c('v-list-tile-action', [_c('div', {
      staticClass: "handle hidden"
    }, [_c('v-icon', {
      staticClass: "no-transition"
    }, [_vm._v("drag_indicator")])], 1)]), _vm._v(" "), _c('v-list-tile-action', [_c('div', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.player.position === i),
        expression: "player.position === i"
      }]
    }, [_c('v-icon', [_vm._v("play_arrow")])], 1)])]), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n                                    " + _vm._s(audio.id) + "\n                                ")]), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.player.position !== i),
        expression: "player.position !== i"
      }],
      staticClass: "hidden no-transition",
      attrs: {
        "icon": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.remove(i)
        }
      }
    }, [_c('v-icon', {
      staticClass: "no-transition"
    }, [_vm._v("delete")])], 1)], 1)], 1)
  }))], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_vm._v("\n                Audios not in playlist:\n                "), _c('v-list', _vm._l((_vm.audiosNotInPlaylist), function(audio, i) {
    return _c('v-list-tile', {
      key: i,
      staticClass: "hover-show-hidden",
      on: {
        "click": function($event) {
          _vm.playAudio(audio)
        }
      }
    }, [_c('v-list-tile-content', [_vm._v("\n                            " + _vm._s(audio.id) + "\n                        ")])], 1)
  }))], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_vm._v("\n                Playlist 1:\n                "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.playPlaylistRandomized(_vm.playlist1)
      }
    }
  }, [_vm._v("Play playlist 1 Randomized")]), _vm._v(" "), _c('v-list', {
    key: 1
  }, [_c('draggable', {
    attrs: {
      "options": _vm.draggableOptions
    },
    model: {
      value: (_vm.playlist1.audios),
      callback: function($$v) {
        _vm.$set(_vm.playlist1, "audios", $$v)
      },
      expression: "playlist1.audios"
    }
  }, _vm._l((_vm.playlist1.audios), function(audio, i) {
    return _c('v-list-tile', {
      key: i,
      staticClass: "hover-show-hidden",
      on: {
        "click": function($event) {
          _vm.playAudio(audio, _vm.playlist1, i)
        }
      }
    }, [_c('v-list-tile-action', [_c('div', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.player.audio && _vm.player.audio.id === audio.id),
        expression: "player.audio && player.audio.id === audio.id"
      }]
    }, [_c('v-icon', [_vm._v("play_arrow")])], 1)])]), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n                                " + _vm._s(audio.id) + "\n                            ")])], 1)
  }))], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_vm._v("\n                Playlist 2:\n                "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.playPlaylistRandomized(_vm.playlist2)
      }
    }
  }, [_vm._v("Play playlist 2 Randomized")]), _vm._v(" "), _c('v-list', {
    key: 2
  }, [_c('draggable', {
    attrs: {
      "options": _vm.draggableOptions
    },
    model: {
      value: (_vm.playlist2.audios),
      callback: function($$v) {
        _vm.$set(_vm.playlist2, "audios", $$v)
      },
      expression: "playlist2.audios"
    }
  }, [_c('transition-group', _vm._l((_vm.playlist2.audios), function(audio, i) {
    return _c('v-list-tile', {
      key: i,
      staticClass: "hover-show-hidden",
      on: {
        "click": function($event) {
          _vm.playAudio(audio, _vm.playlist2, i)
        }
      }
    }, [_c('v-list-tile-action', [_c('div', {
      staticClass: "handle hidden"
    }, [_c('v-icon', {
      staticClass: "no-transition"
    }, [_vm._v("drag_indicator")])], 1)]), _vm._v(" "), _c('v-list-tile-action', [_c('div', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.player.audio && _vm.player.audio.id === audio.id),
        expression: "player.audio && player.audio.id === audio.id"
      }]
    }, [_c('v-icon', [_vm._v("play_arrow")])], 1)])]), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n                                    " + _vm._s(audio.id) + "\n                                ")])], 1)
  }))], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42a8d606","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioPlayer.vue
// module id = 361
// module chunks = 0